module.exports = __webpack_public_path__ + "img/registerbg.3611ebc1.jpg";